import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import { dataLayerPush } from '../../../../resources/frontend/js/mixins/v2.0.0/data-layer-push';

export const useUpsellRedirect = (url = '', category = '') => {
    const upsells = ref([]);
    const upsellsFetched = ref(false);
    const upsellRedirectInterval = ref(null);

    const store = useStore();

    watch(upsellsFetched, (newState, oldState) => {
        if (newState !== oldState && newState === true) {
            const url = new URL(window.location);
            url.searchParams.set('promotions', !upsells.value || upsells.value.length === 0 ? 'false' : 'true');
            window.history.replaceState({}, '', url);
        }
    });

    const handleUpsellRedirect = () => {
        if (!url) {
            console.warn('No upsell URL provided.');
            return;
        }

        if (store.state.page.isPreview) {
            console.log('Upsell redirect skipped in preview mode.');
            return;
        }

        const upsells = fetchUpsells();

        setTimeout(() => {
            redirectToUpsellPage(url);
        }, 3000);

        return upsells;
    };

    const fetchUpsells = async () => {
        const campaignId = store.getters['form/getFieldData']('value', 'sam_campaign_id');
        const zipcode = store.state.page.leadData?.zipcode || store.state.user.location.zipcode;
        const jid = new URLSearchParams(window.location.search).get('jid') || store.state.page.leadData?.jid;

        try {
            let url = `https://lfty.lds.xyz/api/cross-sell/promotion?campaign_id=${campaignId}`;
            if (zipcode) url += `&zipcode=${zipcode}`;
            if (category) url += `&category=${category}`;
            if (jid) url += `&jid=${jid}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(response => response.json());
            upsells.value = response.promotions || [];
            upsellsFetched.value = true;
        } catch (error) {
            console.error('Failed to fetch upsells:', error);
            upsells.value = [];
            upsellsFetched.value = true;
        }

        dataLayerPush('promotions_fetched', {
            zipcode,
            campaignId,
            promotions: upsells.value.map((upsell, index) => ({
                index,
                ...upsell,
            })),
        });

        upsellsFetched.value = true;
    };

    const redirectToUpsellPage = url => {
        if (!upsellsFetched.value) {
            if (!upsellRedirectInterval.value) {
                upsellRedirectInterval.value = setInterval(() => {
                    if (upsellsFetched.value) {
                        clearInterval(upsellRedirectInterval.value);
                        redirectToUpsellPage(url);
                    }
                }, 500);
            }
            return;
        }

        if (!upsells.value || upsells.value.length === 0) {
            console.error('No upsells found.');
            return;
        }

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;

        const data = {
            landing: true,
            ...store.state.page.leadData,
            upsells: upsells.value,
        };

        for (const [key, value] of Object.entries(data)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = JSON.stringify(value);
            form.appendChild(input);
        }

        document.body.appendChild(form);
        form.submit();
    };

    return {
        upsells,
        upsellsFetched,
        upsellRedirectInterval,
        handleUpsellRedirect,
        fetchUpsells,
        redirectToUpsellPage,
    };
};
